import { AjaxPageHandler } from './misc/Ajax';
import { MenuHandler } from './misc/Menu';
import jQuery from "jquery";
import InitMap from './misc/InitMap';
import { ScrollSmoother } from "gsap/ScrollSmoother";

import { gsap } from 'gsap';
import { imagesLoaded } from 'imagesloaded';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

/* Page handlers */
import { HomePageHandler } from './pages/Home';
import { ContactPageHandler } from './pages/Contact';
import { ProfilePageHandler } from './pages/Profile';
import { CvPageHandler } from './pages/Cv';
import { SeminarsPageHandler } from './pages/Seminars';
import { GroupsPageHandler } from './pages/Groups';
import { ArticlesPageHandler } from './pages/Articles';
import { ServicesPageHandler } from './pages/Services';
import { PageHandler } from './pages/PageHandler';
import { SingleServicePageHandler } from './pages/SingleService';
import Swup from 'swup';


class SiteHandler {
	constructor() {
		this.pageHandlers = [
			/* Main pages */
			{ name: 'homePageHandler', class: HomePageHandler, id: 'homepage' },
			{ name: 'contactPageHandler', class: ContactPageHandler, id: 'contact' },
			{ name: 'cvPageHandler', class: CvPageHandler, id: 'cv' },
			{ name: 'seminarsPageHandler', class: SeminarsPageHandler, id: 'seminars' },
			{ name: 'groupsPageHandler', class: GroupsPageHandler, id: 'groups-pink' },
			{ name: 'groupsPageHandler', class: GroupsPageHandler, id: 'groups-blue' },
			{ name: 'profilePageHandler', class: ProfilePageHandler, id: 'profile' },
			{ name: 'articlesPageHandler', class: ArticlesPageHandler, id: 'articles' },
			{ name: 'servicesPageHandler', class: ServicesPageHandler, id: 'services' },
			{ name: 'singleServicePageHandler', class: SingleServicePageHandler, id: 'psychological-service' },

			/* Generic Pages stuff */
			{ name: 'gdprPageHandler', class: PageHandler, id: 'gdpr' },
			{ name: 'termsofusePageHandler', class: PageHandler, id: 'terms-of-use' },
			{ name: 'privacyPageHandler', class: PageHandler, id: 'privacy-policy' },
			{ name: 'cookiesPageHandler', class: PageHandler, id: 'cookies' },
			{ name: 'successPageHandler', class: PageHandler, id: 'success' },
			{ name: 'unsubscribedPageHandler', class: PageHandler, id: 'unsubscribed' },
			{ name: 'thankyouPageHandler', class: PageHandler, id: 'thank-you' },
			{ name: 'managesubscriptionPageHandler', class: PageHandler, id: 'manage-subscription' },
		];
		this.objectHandlers = [
			{ name: 'primaryMenuHandler', class: MenuHandler, id: 'primary-menu' },
		];
	}

	getPageHandler(id) {
		var handler = this.pageHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	getObjectHandler(id) {
		var handler = this.objectHandlers.filter((handler) => handler.id === id)[0];
		return handler ? window[handler.name] : null;
	}

	initHandlers() {
		this.pageHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
		this.objectHandlers.forEach((handler, index) => {
			window[handler.name] = new (handler.class)(handler.id);
		})
	}

	closeMobMenu() {

	}

	events() {
		/* Override anchor clicking */
		jQuery('.no-click a[href^="#"], .expand a[href^="#"]').on('click', function(e) {
			e.preventDefault();
		})
		
		jQuery('body').on('click', '#mob-primary-menu li.menu-item-has-children > a', function(e) {
			e.stopPropagation();
			e.preventDefault();
			var sibling = jQuery(this).siblings('.sub-menu');
			var clone = sibling[0].cloneNode(true);
			var overlay = jQuery('.mob-menu-overlay');
			var parent = jQuery(this).parent();
			
			overlay[0].appendChild(clone)
			gsap.timeline()
			.to('#mob-primary-menu', {autoAlpha: 0})
			.to(clone, {autoAlpha: 1})
		})


		jQuery('body').on('click', '.go-back a', function(e) {
			e.stopPropagation();
			e.preventDefault();
			var overlay = jQuery('.mob-menu-overlay');
			var submenu = overlay.find('> .sub-menu')
			gsap.timeline({onComplete: () => {
				submenu.remove();
			}})
			.to(submenu, {autoAlpha: 0})
			.to('#mob-primary-menu', {autoAlpha: 1})
		})


		// For touch devices, prevent the default behavior of the parent link
		jQuery('.main-navigation:not(#mob-site-navigation) .menu-item-has-children:not(.no-click) > a').on('click', function(e) {
			e.stopPropagation();
			e.preventDefault();
			if ('ontouchstart' in window || navigator.msMaxTouchPoints)
			{
				jQuery(this).siblings('.sub-menu').toggleClass('show') // Toggle the submenu visibility on click
				return;
			}
			else
			{
				window.leaving = true;
				if (!e.target.href)
					ajaxPH.maskOn('/');
				else
					ajaxPH.maskOn(e.target.href);
			}
		});

		
		jQuery('body').on('click', `.main-navigation li:not(.no-click):not(.menu-item-has-children) a[target!='_blank'], 
		button a[target!='_blank'], 
		.polylang_langswitcher a[target!='_blank'],
		footer li a[target!='_blank'], 
		.site-branding a[target!='_blank'], 
		.filter a,
		.go-to-all a,
		.mob-menu-overlay li:not(.menu-item-has-children):not(.go-back) a[target!='_blank']`, function(e) {
			e.stopPropagation();
			e.preventDefault();
			window.leaving = true;
			if (!e.target.href)
				ajaxPH.maskOn('/');
			else
				ajaxPH.maskOn(e.target.href);
		})

		/* Go-to-top button */
		jQuery('.go-to-top').on('click', function() {
			gsap.to(window, {scrollTo: {y: 0}, duration: 0.8})
		})

		/* Mobile menu */
		jQuery('.main-navigation__lines').on('click', function () {
			var me = jQuery(this);
			var openClass = 'main-navigation__lines--open';
			me.toggleClass(openClass);
			if (me.hasClass(openClass)) {
				gsap.set('body, html', {overflow: "hidden", height: "100%"})
				gsap.to('.mob-menu-overlay', {
					duration: 0.3,
					autoAlpha: 1,
					ease: 'power1.inOut'
				});
				gsap.to('.header-social-media', {
					autoAlpha: 1,
					duration: 0.3,
					ease: 'power1.inOut'
				})
			} else {
				gsap.set('body, html', {overflow: "unset", height: 'auto'})
				gsap.to('.mob-menu-overlay', {
					duration: 0.3,
					autoAlpha: 0,
					ease: 'power1.inOut'
				});
				gsap.to('.header-social-media', {
					autoAlpha: 0,
					duration: 0.3,
					ease: 'power1.inOut'
				})
			}
		});

		ScrollTrigger.create({
			trigger: 'header',
			start: 'top top',
			end: '20px top',
			onLeave: () => {
				gsap.to('.go-to-top', {autoAlpha: 1, duration: 0.4})
			},
			onEnterBack: () => {
				gsap.to('.go-to-top', {autoAlpha: 0, duration: 0.4})
			}
		})
	}

	init() {
		gsap.registerPlugin(ScrollTrigger);
		gsap.registerPlugin(ScrollToPlugin);

		this.initHandlers();
		this.events();
		

	}

	destroy() {

	}

	transitions () {
		gsap.to('.transition--background-size', 
			{backgroundSize: "100% 100%", duration: 0.5, ease: 'power2.inout'});
	}
}


	
(function($) {
	$(function() {
		window.global = new SiteHandler();
		window.global.init();
		window.ajaxPH = new AjaxPageHandler();
		ajaxPH.init();

		
		  
		
		const main = document.querySelector('main');
		if (main && window.global.getPageHandler(main.id)) {
			window.global.getPageHandler(main.id).init();
		}
		ajaxPH.maskOff(() => {
			if (main && window.global.getPageHandler(main.id)) {
				window.global.getPageHandler(main.id).transitions();
				window.global.transitions();
			}
		});

		

		window.global.getObjectHandler('primary-menu').init();
		gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, ScrollSmoother);

		// ScrollTrigger.normalizeScroll(true);

		// window.smoother = ScrollSmoother.create({
		// 	smooth: 1.3,
		// 	effects: true
		// });

		document.addEventListener('visibilitychange', function() {
			if (document.visibilityState === 'visible' && window.leaving) {
				ajaxPH.maskOff(() => {
					var openClass = "main-navigation__lines--open";
					if (jQuery('.main-navigation__lines').hasClass(openClass)) {
						jQuery('.main-navigation__lines').removeClass(openClass);
						gsap.set('body, html', {overflow: "unset", height: 'auto'})
						gsap.to('.mob-menu-overlay', {
							duration: 0.3,
							autoAlpha: 0,
							ease: 'power1.inOut'
						});
						gsap.to('.header-social-media', {
							autoAlpha: 0,
							duration: 0.3,
							ease: 'power1.inOut'
						})
					}
				});
			}
		});
			
	})
}(jQuery));